interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = '読み込み中...' }: LoadingStateProps) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-secondary)' }}>
      {message}
    </div>
  );
}
